import { QueuePlayNext } from "@mui/icons-material";
import {
    Avatar,
    Button,
    CircularProgress,
    Container,
    CssBaseline,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import ReactQuill from "react-quill";
import Footer from "../../components/footer";
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars";
import { browserHistory } from "../../helpers/history";
import Api from "../../services/api";
import { Overlay } from "../../styles/global";
import { Styles } from "../../styles/material-styles";
import { connect } from "react-redux";
import { PapiroConsole } from "src/utils/papiroConsole";

class FaqSubjectRegistration extends Component {
    constructor(props) {
        super(props);


        this.reactQuillModules = {
            toolbar: [
                [{ 'header': [1, 2, false] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                ['link', 'image'],
                ['clean']
            ],
        }

        this.reactQuillFormats = [
            'header',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent',
            'link', 'image'
        ]

        this.initialState = {
            name: "",
            description: "",
        };
        this.state = {
            item: this.initialState,
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.handleChangeEditor = this.handleChangeEditor.bind(this);
    }
    handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState((prevState) => ({
            item: {
                ...prevState.item,
                [name]: value,
            },
        }));
    }
    handleChangeEditor(value) {
        this.setState((prevState) => ({
            item: {
                ...prevState.item,
                description: value || "",
            },
        }));
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        let data = { ...this.state.item };
        Api.post("/faq-subject", data)
            .then((result) => {
                if (result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "success",
                        notificationMessage: "Registro salvo com sucesso!",
                        item: this.initialState,
                    });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data && result.data.errors
                                ? result.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    Api.kickoff(result);
                }
            })
            .catch((err) => {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response && err.response.data && err.response.data.errors
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
            });
    };
    closeNotification() {
        this.setState({ openNotification: false });
    }
    render() {
        const { classes } = this.props;
        const { item } = this.state;
        PapiroConsole.log("item")
        PapiroConsole.log(item)
        return (
            <div className={classes.root}>
                <HeaderMenu />
                <main className={clsx(classes.content, classes.actionsContent)}>
                    <div className={classes.drawerHeader} />
                    <Container component="main" maxWidth="md">
                        <CssBaseline />
                        <div className={classes.paper} style={{ marginTop: 0 }}>
                            <Grid container spacing={6}>
                                <Grid item xs={12} sm={4}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={browserHistory.goBack}
                                    >
                                        Voltar
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={8} />
                            </Grid>
                            <Avatar className={classes.avatar}>
                                <QueuePlayNext />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                {<FormattedMessage id="add.item" />}
                            </Typography>
                            <form
                                name="faqSubjectForm"
                                className={classes.form}
                                onSubmit={this.handleSubmit}
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            inputProps={{ maxLength: 250 }}
                                            fullWidth
                                            label="Nome"
                                            variant="outlined"
                                            name="name"
                                            onChange={this.handleInputChange}
                                            value={item.name}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography>Descrição</Typography>

                                        <div
                                            style={{
                                                resize: "vertical",
                                                overflow: "auto",
                                                height: "250px",
                                                marginBottom: "24px",
                                                border: "1px solid #ccc",
                                            }}
                                        >
                                            <ReactQuill
                                                name="description"
                                                value={item.description}
                                                style={{ height: "100%" }}
                                                modules={this.reactQuillModules}
                                                formats={this.reactQuillFormats}
                                                fullWidth
                                                variant="outlined"
                                                id="answer"
                                                onChange={(value) =>
                                                    this.handleChangeEditor(value, "description")
                                                }
                                            />
                                        </div>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        style={{
                                            marginTop: 15,
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: 15,
                                        }}
                                    >
                                        <Grid
                                            container
                                            justify="flex-end"
                                            style={{ justifyContent: "flex-end" }}
                                        >
                                            <Grid item xs={12} sm={4}>
                                                <Button
                                                    type="submit"
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.submit}
                                                >
                                                    {<FormattedMessage id="save" />}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        </div>
                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}
FaqSubjectRegistration.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default injectIntl(withStyles(Styles)(FaqSubjectRegistration));
